import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-bi-cteam',
  templateUrl: './power-bi-cteam.component.html',
  styleUrls: ['./power-bi-cteam.component.css']
})
export class PowerBiCTEAMComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
